import { Box, Grid, Button, Checkbox, Typography, useMediaQuery, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { createSelector } from '@reduxjs/toolkit'
import React, { useContext, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { Link, useLocation } from 'react-router-dom'
import ErrorAlert from '../../Layouts/ErrorAlert'
import { AuthContext } from '../../libs/contexts/authContext'
import { filterNonDigits, isValidEmail, isValidPhoneNumber } from '../../libs/utils'
import { createAccount } from '../../store/actions/authActions'
import { selectMsgText, selectMsgTitle } from './utils'
import FirstRegisterStepV2, { checkLowerCase, checkSpecialChars, checkUppercase } from './FirstRegisterStepV2'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SecondRegisterStepV2, { validateZipCode } from './SecondRegisterStepV2'
import ThirdRegisterStepV2 from './ThirdRegisterStepV2'
import EntryRight from "../../images/entry-right.svg"
import StepComplete from '../../images/step-complete.svg'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useEffect } from 'react'
import { is } from 'date-fns/locale'
import { MutateCreateAccount, MutateCreateAffiliateCode } from '../../libs/hooks/mutations'
import { QueryContext } from '../../libs/contexts/queryContext'

// const StyledLink = styled(Link)({
//   color: 'blue',
//   textDecoration: 'none',

//   '&:focus, &:hover, &:visited, &:link, &:active': {
//     color: 'blue',
//   },
// })

// styled(Tab)({
//     textTransform: 'none',
//     fontSize: '12px',
//     fontWeight: '600',
//     color:"#AEB7C3",
//     '&.MuiTabs-indicator': {
//         display: 'flex',
//         justifyContent: 'center',
//         // backgroundColor: 'black!important',
//       }
//   })

// const TabIcon = ({ step, selected }) => {
//   return (
//     <Typography
//       sx={
//         selected
//           ? {
//               color: '#fff',
//               width: '20px',
//               height: '20px',
//               backgroundColor: '#3C4FB9',
//               borderRadius: '50%',
//               fontSize: '12px',
//               lineHeight: '20px',
//               margin: '0 auto 6px auto',
//             }
//           : {
//               color: '#AEB7C3',
//               width: '20px',
//               height: '20px',
//               backgroundColor: '#E8EBF1',
//               borderRadius: '50%',
//               fontSize: '12px',
//               lineHeight: '20px',
//               margin: '0 auto 6px auto',
//             }
//       }
//       mb={'5px'}
//     >
//       {step}
//     </Typography>
//   )
// }

// const StyledTab = ({ isMobile, selected, complete, step, number, onSelect }) => {
//   return (
//     <Grid
//       item
//       sm={isMobile ? 12 : 4}
//       xs={isMobile ? 12 : 4}
//       height={'100%'}
//       style={!isMobile ? { borderBottom: `2px solid ${complete || selected ? '#3C4FB9' : '#CBD2DB'}` } : {}}
//     >
//       {!isMobile ? (
//         <Box onClick={() => onSelect()} sx={{ cursor: 'pointer' }}>
//           {complete ? (
//             <CheckCircleIcon sx={{ fontSize: '22px', color: '#3C4FB9' }} />
//           ) : (
//             <TabIcon step={number} selected={selected} />
//           )}
//           <Typography fontSize={'12px'} mb={'5px'} color={selected ? '#3C4FB9' : '#AEB7C3'}>
//             {step}
//           </Typography>
//         </Box>
//       ) : (
//         <Box
//           onClick={() => onSelect()}
//           maxWidth={'311px'}
//           boxShadow="0px 4px 20px -4px rgba(16, 24, 40, 0.1)"
//           borderRadius={'8px'}
//           justifyContent={'space-between'}
//           display={'flex'}
//           alignItems={'center'}
//           py={'32px'}
//           px={'16px'}
//           bgcolor={complete ? '#EFFBFA' : '#fff'}
//         >
//           <Box display={'flex'} gap={'24px'} alignItems="center" height={'53px'} maxWidth={'70%'}>
//             {complete && <img src={StepComplete} alt="complete" width={'53px'} />}
//             <Typography textAlign={'left'} fontSize={'20px'} fontWeight={'500'} color="#3C4FB9">
//               {step}
//             </Typography>
//           </Box>
//           <img src={EntryRight} alt="entry-right" width={'53px'} />
//         </Box>
//       )}
//     </Grid>
//   )
// }

export const selectNecessaryProps = createSelector([selectMsgTitle, selectMsgText], (msgTitle, msgText) => ({
  msgTitle,
  msgText,
}))

function RegisterPageV2() {
  const { search } = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { affiliateCode, invalidUrl, urlErrorMessage } = useContext(AuthContext)
  const { verifiedEmail, verifiedAgentCode } = useContext(QueryContext)
  const { msgTitle, msgText } = useSelector(selectNecessaryProps)
  const [sameAddress, setSameAddress] = useState(false)
  const [agreedCheckbox, setAgreedCheckbox] = useState(false)
  const [registrationForm, setRegistrationForm] = useState({
    workEmail: '',
    password: '',
    confirmPassword: '',
    organizationName: '',
    workAgentPhone: '',
    profilePhoto: null,
    firstName: '',
    lastName: '',
    personalEmail: '',
    personalPhone: '',
    personalWebsite: '',
    isSameAddress: false,
  })

  const [companyInfo, setCompanyInfo] = useState({
    distributorId: '8973',
    organizationName: 'Quility',
    producerId: '',
  })

  const [personalAddress, setPersonalAddress] = useState({
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
  })
  const [workAddress, setWorkAddress] = useState({
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
  })
  // const [currStep, setCurrStep] = useState(0)
  // const [stepsCompleted, setStepsCompleted] = useState({
  //   0: false,
  //   1: false,
  //   2: false,
  // })

  const [error, setError] = useState({
    msgText: '',
    msgTitle: '',
  })

  const [showError, setShowError] = useState(false)

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))

  const {
    mutate: createAffiliateCode,
    data: createAffiliateCodeRes,
    isError: isCreatreAffiliateCodeError,
    error: createAffiliateCodeError,
    isPending: creatingAffiliateCode,
    isSuccess: createAffiliateCodeSuccess,
  } = MutateCreateAffiliateCode()
  const {
    mutate: createAccount,
    data: createAccountRes,
    isError: isCreateAccountError,
    error: createAccountError,
    isPending: creatingAccount,
  } = MutateCreateAccount()

  // useEffect(() => {
  //   if (isMobile) {
  //     setCurrStep(null)
  //   } else {
  //     setCurrStep(Object.values(stepsCompleted).indexOf(false))
  //   }
  // }, [isMobile])

  useEffect(() => {
    if (createAffiliateCodeError) {
      console.log(createAffiliateCodeError)
      setError({ msgText: createAffiliateCodeError.msgText, msgTitle: createAffiliateCodeError.msgTitle })
      return setShowError(true)
    }
    console.log({ createAffiliateCodeSuccess })
    if (!createAffiliateCodeSuccess || !createAffiliateCodeRes) return
    const createAccountPayload = {
      agent_id: createAffiliateCodeRes.AffiliateCode,
      login: registrationForm.workEmail,
      password: registrationForm.password,
      workAgentPhone: registrationForm.workAgentPhone,
      workZipCode: workAddress.zipCode,
      workAddress1: workAddress.address1,
      workAddress2: workAddress.address2,
      workCity: workAddress.city,
      workState: workAddress.state,
      firstName: registrationForm.firstName,
      lastName: registrationForm.lastName,
      personalEmailAddess: registrationForm.personalEmail,
      personalPhone: registrationForm.personalPhone,
      homeZipCode: personalAddress.zipCode,
      homeAddress1: personalAddress.address1,
      homeAddress2: personalAddress.address2,
      homeCity: personalAddress.city,
      homeState: personalAddress.state,
      agentPersonalWeb: registrationForm.personalWebsite,
      agentPhoto: registrationForm.profilePhoto,
      isSameAddress: sameAddress,
      productId: 4127,
    }
    console.log({ createAccountPayload })
    createAccount(createAccountPayload)
  }, [createAffiliateCodeSuccess, createAffiliateCodeError])

  useEffect(() => {
    if (isCreateAccountError || !createAccountRes) {
      if (createAccountError) {
        setError({ msgText: createAccountError.msgText, msgTitle: createAccountError.msgTitle })
        return setShowError(true)
      }
      return
    }
    console.log({ createAccountRes })
    navigate(`/login/?productId=4127&affiliateCode=${createAffiliateCodeRes.AffiliateCode}`)
  }, [createAccountRes, createAffiliateCodeRes, isCreateAccountError])

  // const emailVerified = registrationForm.workEmail === verifiedEmail
  // const agentVerified = companyInfo.producerId === verifiedAgentCode

  // useEffect(() => {
    // if (currStep === null) return
    // let complete = false
    // switch (currStep) {
    //   case 0:
        // const { workEmail, password, confirmPassword } = registrationForm
        // if (
        //   ['firstName', 'lastName', 'workEmail', 'password', 'confirmPassword'].every(
        //     (key) => registrationForm[key] !== ''
        //   ) &&
        //   workEmail.length > 4 &&
        //   isValidEmail(workEmail) &&
        //   password.length > 11 &&
        //   checkUppercase(password) &&
        //   checkLowerCase(password) &&
        //   checkSpecialChars(password) &&
        //   password === confirmPassword &&
        //   emailVerified &&
        //   agentVerified
        // ) {
        //   complete = true
        // }

        // setStepsCompleted((prev) => ({
        //   ...prev,
        //   0: complete,
        // }))
        // break

      // case 1:
      //   const { workAgentPhone } = registrationForm
      //   const { state, zipCode } = workAddress
      //   if (
      //     ['workAgentPhone'].every((key) => registrationForm[key] !== '') &&
      //     ['distributorId', 'organizationName', 'agentId'].every((key) => companyInfo[key] !== '') &&
      //     ['address1', 'city', 'state', 'zipCode'].every((key) => workAddress[key] !== '') &&
      //     zipCode !== '' &&
      //     zipCode.length === 5 &&
      //     !validateZipCode(zipCode, state) &&
      //     isValidPhoneNumber(workAgentPhone)
      //   ) {
      //     complete = true
      //   }
      //   setStepsCompleted((prev) => ({
      //     ...prev,
      //     1: complete,
      //   }))
      //   break

      // case 2:
      //   const { personalEmail, personalPhone } = registrationForm
      //   const { state: pState, zipCode: pZipCode } = personalAddress
      //   if (
      //     ['firstName', 'lastName', 'personalPhone'].every((key) => registrationForm[key] !== '') &&
      //     ['address1', 'city', 'state', 'zipCode'].every((key) => personalAddress[key] !== '') &&
      //     pZipCode.length === 5 &&
      //     !validateZipCode(pZipCode, pState) &&
      //     agreedCheckbox
      //   ) {
      //     complete = true
      //     if (
      //       (personalEmail.trim().length > 0 && !isValidEmail(personalEmail)) ||
      //       (personalPhone.trim().length > 0 && !isValidPhoneNumber(personalPhone))
      //     )
      //       complete = false
      //   } else {
      //     console.log('step 3 not completed')
      //   }
      //   setStepsCompleted((prev) => ({
      //     ...prev,
      //     2: complete,
      //   }))
      //   break
  //     default:
  //       break
  //   }
  // }, [currStep, registrationForm, companyInfo, personalAddress, workAddress, agreedCheckbox])

  // const handleRegistrationFormChange = ({ target: { files, name, value } }) => {
  //   if (name === 'profilePhoto') {
  //     const file = files[0]
  //     if (file && (file.type === 'image/png' || file.type === 'image/jpeg')) {
  //       const fileBytes = URL.createObjectURL(file)
  //       setRegistrationForm({
  //         ...registrationForm,
  //         profilePhoto: fileBytes,
  //       })
  //     }
  //     return
  //   } else if (name === 'personalPhone' || name === 'workAgentPhone') {
  //     const phoneNumber = filterNonDigits(value)
  //     setRegistrationForm((prev) => ({
  //       ...prev,
  //       [name]: phoneNumber,
  //     }))
  //     return
  //   }
  //   setRegistrationForm({
  //     ...registrationForm,
  //     [name]: value,
  //   })
  // }

  const handleSubmit = async () => {
    const createAffiliatePayload = {
      AgencyId: '53388',
      PlatformToken: 'SQZInjDbGjm9tN1t',
      agentCity: personalAddress.city,
      agentName: `${registrationForm.firstName} ${registrationForm.lastName}`,
      apptendDate: '2025-12-12',
      distributorId: companyInfo.distributorId,
      agentEmail: registrationForm.workEmail,
      carrierId: '9876',
      producerId: companyInfo.producerId,
      productId: '4127',
      agentFirstName: registrationForm.firstName,
      agentLastName: registrationForm.lastName,
      agentPhone: registrationForm.workAgentPhone,
      agentWorkAddress1: `${workAddress.address1}${workAddress.address2?.trim().length > 0 ? ', ' : ''}${
        workAddress.address2
      }`,
      agentWorkState: workAddress.state,
      agentWorkCity: workAddress.city,
      agentWorkZip: workAddress.zipCode,
    }
    console.log({ createAffiliatePayload })
    createAffiliateCode(createAffiliatePayload)

    // const res = await dispatch(createAccount(formInput))
    // if (res.statusCode === 201) {
    //   setShowError(true)
    // }
    // if (res && res.accountCreated) {
    //   setShowError(false)
    //   navigate(`/success?affiliateCode=${affiliateCode}`)
    // } else {
    //   setShowError(true)
    // }
  }

  // const handleNext = () => {
  //   setCurrStep(isMobile ? null : currStep + 1)
  // }

  // const getTitle = (step) => {
  //   switch (step) {
  //     case 0:
  //       return 'Login Info'
  //     case 1:
  //       return 'About your Company'
  //     case 2:
  //       return 'About you'
  //     default:
  //       return ''
  //   }
  // }

  useEffect(() => {
    console.log(error)
  }, [error])

  // const handleSteps = () => {
  //   switch (currStep) {
  //     case 0:
      //  // return (
      //  //   <FirstRegisterStep
      //  //     registrationForm={registrationForm}
      //  //     handleRegistrationFormChange={handleRegistrationFormChange}
      //  //     setRegistrationForm={setRegistrationForm}
      //  //     handleNext={handleNext}
      //  //   />
        // )
        // return (
          // <FirstRegisterStepV2
          //   registrationForm={registrationForm}
          //   setRegistrationForm={setRegistrationForm}
          //   handleNext={handleNext}
          //   setErrorContent={setError}
          //   setAgentVerifyError={setShowError}
          //   setWorkAddress={setWorkAddress}
          //   setPersonalAddress={setPersonalAddress}
          //   companyInfo={companyInfo}
          //   setCompanyInfo={setCompanyInfo}
          //   workAddress={workAddress}
          //   personalAddress={personalAddress}
          //   handleSubmit={handleSubmit}
          //   agreedCheckbox={agreedCheckbox}
          //   setAgreedCheckbox={setAgreedCheckbox}
          //   formComplete={Object.values(stepsCompleted).every((val) => val === true)}
          //   loading={creatingAffiliateCode || creatingAccount}

          // />
        // )
      // case 1:
      //   return (
      //     <SecondRegisterStepV2
      //       registrationForm={registrationForm}
      //       setRegistrationForm={setRegistrationForm}
      //       handleRegistrationFormChange={handleRegistrationFormChange}
      //       workAddress={workAddress}
      //       setWorkAddress={setWorkAddress}
      //       handleNext={handleNext}
      //       companyInfo={companyInfo}
      //       setCompanyInfo={setCompanyInfo}
      //     />
      //   )
      // case 2:
      //   return (
      //     <ThirdRegisterStepV2
      //       registrationForm={registrationForm}
      //       setRegistrationForm={setRegistrationForm}
      //       handleRegistrationFormChange={handleRegistrationFormChange}
      //       personalAddress={personalAddress}
      //       workAddress={workAddress}
      //       setPersonalAddress={setPersonalAddress}
      //       handleSubmit={isMobile ? handleNext : handleSubmit}
      //       agreedCheckbox={agreedCheckbox}
      //       setAgreedCheckbox={setAgreedCheckbox}
      //       formComplete={Object.values(stepsCompleted).every((val) => val === true)}
      //       loading={creatingAffiliateCode || creatingAccount}
      //     />
      //   )

  //     default:
  //       return <></>
  //   }
  // }

  if (isMobile) {
    // if (currStep === null) {
      return (
        <>
          <ErrorAlert
            showError={invalidUrl || showError}
            setShowError={setShowError}
            msgTitle={error.msgTitle || msgTitle}
            messageText={urlErrorMessage || error.msgText || msgText}
          />
          <Box sx={registerStyle.containerBox}>
            {/* <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: { lg: '64px 52px', md: '40px 32px ', sm: '40px 32x', xs: '16px' },
              }}
            >
              <Typography
                variant="h5"
                width={'100%'}
                fontWeight={'600'}
                textAlign={'left'}
                sx={{ mt: '6px', mb: '6px' }}
              >
                Create an Account
              </Typography>
              <Typography
                variant="subtitle2"
                width={'100%'}
                textAlign={'left'}
                color="#36414E"
                sx={{ mt: '6px', fontFamily: 'Roboto !important' }}
              >
                Register to access Life Insurance Applications Portal products and manage your applications.
              </Typography>  */}

              {/* <Grid
                container
                width={'100%'}
                justifyContent={'center'}
                alignItems={'flex-start'}
                mt={2}
                mb={5}
                rowSpacing={isMobile ? '16px' : ''}
              > */}
                {/* <Grid item xs={12}>
                  <Typography
                    width={'100%'}
                    fontWeight={'600'}
                    textAlign={'left'}
                    fontSize="20px"
                    color="#56677B"
                    sx={{ mt: '6px' }}
                  >
                    Complete each section
                  </Typography>
                </Grid> */}
                <FirstRegisterStepV2
                  registrationForm={registrationForm}
                  setRegistrationForm={setRegistrationForm}
                  // handleNext={handleNext}
                  setErrorContent={setError}
                  setAgentVerifyError={setShowError}
                  setWorkAddress={setWorkAddress}
                  setPersonalAddress={setPersonalAddress}
                  companyInfo={companyInfo}
                  setCompanyInfo={setCompanyInfo}
                  workAddress={workAddress}
                  personalAddress={personalAddress}
                  handleSubmit={handleSubmit}
                  agreedCheckbox={agreedCheckbox}
                  setAgreedCheckbox={setAgreedCheckbox}
                  // formComplete={Object.values(stepsCompleted).every((val) => val === true)}
                  loading={creatingAffiliateCode || creatingAccount}
                  />
                {/* <StyledTab
                  isMobile={isMobile}
                  selected={Boolean(currStep === 0)}
                  complete={stepsCompleted[0]}
                  step={'Login Info'}
                  number={1}
                  onSelect={() => setCurrStep(0)}
                />
                <StyledTab
                  isMobile={isMobile}
                  selected={Boolean(currStep === 1)}
                  complete={stepsCompleted[1]}
                  step={'About your Company'}
                  number={2}
                  onSelect={() => setCurrStep(1)}
                />
                <StyledTab
                  isMobile={isMobile}
                  selected={Boolean(currStep === 2)}
                  complete={stepsCompleted[2]}
                  step={'About you'}
                  number={3}
                  onSelect={() => setCurrStep(2)}
                /> */}
                {/* <Grid item xs={12}>
                  <Box
                    width={'100%'}
                    gap={'5px'}
                    mt={1}
                    display={'flex'}
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                  >
                    <Checkbox
                      label="terms-check"
                      required
                      checked={agreedCheckbox}
                      sx={{ padding: 0 }}
                      onClick={() => {
                        setAgreedCheckbox(!agreedCheckbox)
                      }}
                    />
                    <Typography fontSize={'14px'} textAlign={'left'}>
                      I agree to the{' '}
                      <a href="https://www.afficiency.com/terms-of-service" target="_blank" rel="noopener noreferrer">
                        Terms of Service
                      </a>{' '}
                      and{' '}
                      <a href="https://www.afficiency.com/privacy-policy" target="_blank" rel="noopener noreferrer">
                        Privacy Policy
                      </a>
                    </Typography>
                  </Box>
                </Grid> */}
                {/* <Grid item mt={3} xs={12}>
                  <Button
                    sx={{
                      textTransform: 'none',
                      width: { xs: '100%' },
                      height: '40px',
                      backgroundColor: '#3C4FB9',
                      color: 'white',
                      borderRadius: '100px',
                      mt: '2px',
                      '&:hover': {
                        backgroundColor: '#9BA5DF',
                        color: '#36414E',
                      },
                      '&:disabled': {
                        backgroundColor: '#C4CAF1',
                        color: 'white',
                        textTransform: 'none',
                      },
                    }}
                    // disabled={Object.values(stepsCompleted).some((val) => val === false) || !agreedCheckbox}
                    onClick={handleSubmit}
                  >
                    Create Account
                  </Button>
                </Grid> */}
              {/* </Grid> */}
            {/* </Box> */}
          </Box>
        </>
      )
    // } else {
    //   return (
    //     <Box sx={registerStyle.stepBox}>
    //       <Box
    //         width="100%"
    //         display="flex"
    //         justifyContent={'flex-start'}
    //         alignItems={'center'}
    //         px={1}
    //         py={1}
    //         mb={2}
    //         borderBottom={'1px solid #E8EBF1'}
    //       >
    //         <IconButton onClick={() => setCurrStep(null)}>
    //           <ArrowBackIcon sx={{ fontSize: '12px', color: '#3C4FB9' }} />
    //         </IconButton>
    //         <Typography fontSize={'16px'} fontWeight={'700'}>
    //           {getTitle(currStep)}
    //         </Typography>
    //       </Box>
    //       <Box px={1.5}>{handleSteps()}</Box>
    //     </Box>
    //   )
    // }
  }

  return (
    <>
      <ErrorAlert
        showError={invalidUrl || showError}
        setShowError={setShowError}
        msgTitle={error.msgTitle || msgTitle}
        messageText={urlErrorMessage || error.msgText || msgText}
      />
      <Box sx={registerStyle.containerBox}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: { lg: '64px 52px', md: '40px 32px ', sm: '40px 32x', xs: '16px' },
          }}
        >
          <Typography variant="h4" align="center" sx={{ mt: '6px', mb: '6px' }}>
            Create an Account
          </Typography>
          <Typography variant="subtitle2" align="center" sx={{ mt: '6px', fontFamily: 'Roboto !important' }}>
            Register to access Life Insurance Applications Portal products and manage your applications.
          </Typography>
          {/* <Grid
            container
            width={'100%'}
            justifyContent={'center'}
            alignItems={'flex-start'}
            mt={2}
            mb={5}
            rowSpacing={isMobile ? '16px' : ''}
          >
            <StyledTab
              selected={Boolean(currStep === 0)}
              complete={stepsCompleted[0]}
              step={'Login Info'}
              number={1}
              onSelect={() => setCurrStep(0)}
            />
            <StyledTab
              selected={Boolean(currStep === 1)}
              complete={stepsCompleted[1]}
              step={'About your Company'}
              number={2}
              onSelect={() => setCurrStep(1)}
            />
            <StyledTab
              selected={Boolean(currStep === 2)}
              complete={stepsCompleted[2]}
              step={'About you'}
              number={3}
              onSelect={() => setCurrStep(2)}
            />
          </Grid> */}

          {/* {handleSteps()} */}
          <FirstRegisterStepV2
            registrationForm={registrationForm}
            setRegistrationForm={setRegistrationForm}
            // handleNext={handleNext}
            setErrorContent={setError}
            setAgentVerifyError={setShowError}
            setWorkAddress={setWorkAddress}
            setPersonalAddress={setPersonalAddress}
            companyInfo={companyInfo}
            setCompanyInfo={setCompanyInfo}
            workAddress={workAddress}
            personalAddress={personalAddress}
            handleSubmit={handleSubmit}
            agreedCheckbox={agreedCheckbox}
            setAgreedCheckbox={setAgreedCheckbox}
            // formComplete={Object.values(stepsCompleted).every((val) => val === true)}
            loading={creatingAffiliateCode || creatingAccount}

          />
        </Box>
      </Box>
    </>
  )
}

export default RegisterPageV2

const registerStyle = {
  containerBox: {
   borderRadius: '8px',
    width: { lg: '626px', md: '770px', sm: '770px', xs: '375px' },
    height: {xs: '737px', sm: 'auto'},
    background: {lg: '#F5F7FF', md: '#F5F7FF', sm: '#F5F7FF', xs: 'transparent'},
    margin: {xs: '40px auto', sm: '100px auto'},
  },
  stepBox: {
    width: "100%",
    height: "100%",
    marginTop: "80px",
  }
}
